import { sectionTitle, stampLabel, toDate } from "./notificationTime";

export const groupNotifications = (items, now = new Date()) => {
  const sections = [];

  (items || []).forEach((item) => {
    const date = toDate(item.createdAt);
    const title = sectionTitle(date, now);
    const row = { ...item, stamp: date ? stampLabel(date, now) : item.dateLabel };

    const current = sections[sections.length - 1];

    if (current && current.title === title) {
      current.items.push(row);

      return;
    }

    sections.push({ title, items: [row] });
  });

  return sections;
};
